import { CustomerSurvey } from './customer-survey-data.model';
import { MercerSurveyType } from '@coin/shared/core/util-enums';
import { MercerCareerStream } from './mercer-career-stream.enum';

export const MERCER_PROJECT_MANAGEMENT_SURVEY: CustomerSurvey = {
  id: 'df0f6a93-5b50-4efb-a3a4-646d2295eed0',
  surveyType: MercerSurveyType.ProjectManagement,
  questions: [
    {
      id: '0bffa73b-19cc-488d-864b-4174d696ab56',
      isActive: true,
      treeLevel: 0,
      title: 'survey.mercer-project-manager.q2-question',
      answers: [
        {
          id: 'ed9a0fbb-785f-42d3-9c49-a7c22b416d61',
          title: 'survey.mercer-project-manager.q2-answer-a-title',
          linkedSurveyQuestionId: '56e1f650-a180-42a3-bf99-859f8acef6ae'
        },
        {
          id: '25c6ec7a-c990-4b00-84a0-6b3eeebbb59b',
          title: 'survey.mercer-project-manager.q2-answer-b-title',
          linkedSurveyQuestionId: '3cdd1eff-2f34-4969-b3bc-835f7cbdac7c'
        }
      ]
    },
    {
      id: '56e1f650-a180-42a3-bf99-859f8acef6ae',
      treeLevel: 1,
      title: 'survey.mercer-project-manager.q3-question',
      answers: [
        {
          id: '67e37dcf-74b9-4a21-98d7-74feb9cfcba5',
          title: 'general.yes',
          linkedSurveyQuestionId: '679a7eae-7994-40b6-96f8-0debf23ec59a'
        },
        {
          id: '1d638f98-1771-4041-aba9-90d432c3c2cd',
          title: 'general.no',
          linkedSurveyQuestionId: 'd6a91a92-0f40-4fa5-a02a-f0a7de53c55e'
        }
      ]
    },
    {
      id: 'd6a91a92-0f40-4fa5-a02a-f0a7de53c55e',
      treeLevel: 2,
      title: 'survey.mercer-project-manager.q4-question',
      answers: [
        {
          id: '64db3fdb-1eaa-468b-b064-281c548ca1a1',
          title: 'general.yes',
          linkedSurveyQuestionId: '3455e746-8591-4f0d-8fec-783f15c9febb'
        },
        {
          id: '01646747-9058-4a17-b81d-753b3c23a8d3',
          title: 'general.no',
          linkedSurveyQuestionId: '3034bcad-0240-4f4a-a88c-f6d8841f01fb'
        }
      ]
    },
    {
      id: '3034bcad-0240-4f4a-a88c-f6d8841f01fb',
      treeLevel: 3,
      title: 'survey.mercer-project-manager.q5-question',
      answers: [
        {
          id: 'fac2ee32-b07c-4d6c-8d41-d03d0b5bd659',
          title: 'general.yes',
          linkedSurveyQuestionId: 'c48cbe2e-38b0-42bd-9887-dd164822d782'
        },
        {
          id: 'bc1903d8-0016-4460-acb6-7e246fb3d481',
          title: 'general.no',
          linkedSurveyQuestionId: '7d485a08-9e22-4bd7-9430-55d35c340b65'
        }
      ]
    },
    {
      id: '7d485a08-9e22-4bd7-9430-55d35c340b65',
      treeLevel: 4,
      title: 'survey.mercer-project-manager.q6-question',
      answers: [
        {
          id: '895593be-4352-4e07-ada1-fb833e93dea6',
          title: 'general.yes',
          linkedSurveyQuestionId: '1d31bbb9-77a1-4ffb-86b3-9295a83556be'
        },
        {
          id: 'ba2bd599-86a5-477d-80df-14b2003d3b12',
          title: 'general.no',
          linkedSurveyResultId: '8149133e-7c07-442f-99cb-9aba398a8218'
        }
      ]
    },
    {
      id: '679a7eae-7994-40b6-96f8-0debf23ec59a',
      treeLevel: 2,
      title: 'survey.mercer-project-manager.q7-question',
      answers: [
        {
          id: 'd2e6fcd3-7011-4cf0-8e6c-f903a27de889',
          title: 'general.yes',
          linkedSurveyQuestionId: '65521565-3cd9-40e6-b753-d1e239d68d5b'
        },
        {
          id: 'f9ffcc74-f2e9-4754-b8d6-2c26cc80b5a1',
          title: 'general.no',
          linkedSurveyQuestionId: 'aad77be7-245b-4ccc-aae2-63215b9c7097'
        }
      ]
    },
    {
      id: '3455e746-8591-4f0d-8fec-783f15c9febb',
      treeLevel: 3,
      title: 'survey.mercer-project-manager.q10-question',
      answers: [
        {
          id: '4384dccd-39c7-4fcb-a144-9bfcbed58042',
          title: 'general.yes',
          linkedSurveyQuestionId: '8eac8989-e844-4906-9da0-2509f14ea6a6'
        },
        {
          id: '2711a8c3-cbbd-4d1e-8155-d92cdb720d15',
          title: 'general.no',
          linkedSurveyQuestionId: 'b43eb5a4-afe7-4f84-a191-ae061759f974'
        }
      ]
    },
    {
      id: 'c48cbe2e-38b0-42bd-9887-dd164822d782',
      treeLevel: 4,
      title: 'survey.mercer-project-manager.q13-question',
      answers: [
        {
          id: '4b69abc8-5c8d-4bb2-9714-95b9b5b4c50c',
          title: 'general.yes',
          linkedSurveyQuestionId: 'a33571d2-9fa1-4ca1-8f22-6c951e7c2ddc'
        },
        {
          id: 'aeb484cb-b137-4e02-a4d8-44a98e284248',
          title: 'general.no',
          linkedSurveyQuestionId: 'aafcd74c-2a5e-414a-9f51-ca57ce2fa82b'
        }
      ]
    },
    {
      id: '1d31bbb9-77a1-4ffb-86b3-9295a83556be',
      treeLevel: 5,
      title: 'survey.mercer-project-manager.q16-question',
      answers: [
        {
          id: 'd8cef2cf-10a1-4972-93f9-b4f9e1f2a8e0',
          title: 'general.yes',
          linkedSurveyResultId: '17120a3d-964c-4efd-80af-b8a3a4f5fe39'
        },
        {
          id: '947a86b2-b006-4f1a-b634-bca68eb8c42d',
          title: 'general.no',
          linkedSurveyResultId: 'ddfaabe2-4fb3-4466-97c1-78bcc7c4140e'
        }
      ]
    },
    {
      id: '65521565-3cd9-40e6-b753-d1e239d68d5b',
      treeLevel: 3,
      title: 'survey.mercer-project-manager.q8-question',
      answers: [
        {
          id: '5d6d43af-c6bb-4897-aa28-789b5fbb419e',
          title: 'general.yes',
          linkedSurveyResultId: '669c2880-66be-473a-a2bf-d3db999dc174'
        },
        {
          id: '3d863ad6-d2e2-4a6c-a781-0d4da0d742c8',
          title: 'general.no',
          linkedSurveyResultId: 'b0511ed0-241f-435d-977c-147da3fbd88c'
        }
      ]
    },
    {
      id: 'aad77be7-245b-4ccc-aae2-63215b9c7097',
      treeLevel: 3,
      title: 'survey.mercer-project-manager.q9-question',
      answers: [
        {
          id: 'aacf2f80-1521-467f-b57f-3e7416135a37',
          title: 'general.yes',
          linkedSurveyResultId: '1dfe08d4-abbc-419e-ad24-aecbe92ceeaf'
        },
        {
          id: 'e2beec9c-a246-434d-acff-9c1d276e39d3',
          title: 'general.no',
          linkedSurveyResultId: 'eb7d4e92-a61c-4dca-aa77-d1b123e0236c'
        }
      ]
    },
    {
      id: '8eac8989-e844-4906-9da0-2509f14ea6a6',
      treeLevel: 4,
      title: 'survey.mercer-project-manager.q11-question',
      answers: [
        {
          id: 'f00fbd4f-355c-447e-87d5-e71c3934d7e0',
          title: 'general.yes',
          linkedSurveyResultId: 'a97ba484-b880-408d-82ad-2a1c46667554'
        },
        {
          id: 'ca9bf728-5c10-47bb-be35-3b32025d4a46',
          title: 'general.no',
          linkedSurveyResultId: '99ac1b82-43d7-44e1-8dd7-b831ee3f6f28'
        }
      ]
    },
    {
      id: 'b43eb5a4-afe7-4f84-a191-ae061759f974',
      treeLevel: 4,
      title: 'survey.mercer-project-manager.q12-question',
      answers: [
        {
          id: '8f20ff5e-ae9d-4c08-b891-b3da264e1e2a',
          title: 'general.yes',
          linkedSurveyResultId: 'd8cc6063-c1b8-41dc-a944-3f31e177743c'
        },
        {
          id: '8fe2d283-adda-4451-8666-27a14658b72a',
          title: 'general.no',
          linkedSurveyResultId: 'd8aa96c8-41a1-4334-bc96-f76b08ad9370'
        }
      ]
    },
    {
      id: 'a33571d2-9fa1-4ca1-8f22-6c951e7c2ddc',
      treeLevel: 5,
      title: 'survey.mercer-project-manager.q14-question',
      answers: [
        {
          id: '6ae3fe9f-a7ee-4c61-b2a6-47025ad89e19',
          title: 'general.yes',
          linkedSurveyResultId: '7111628f-773f-420a-8f87-22f8fbf604bc'
        },
        {
          id: 'c613968d-f3df-4dc8-88cf-47c217de3eec',
          title: 'general.no',
          linkedSurveyResultId: 'a8999851-8244-47bd-a917-f47e738db294'
        }
      ]
    },
    {
      id: 'aafcd74c-2a5e-414a-9f51-ca57ce2fa82b',
      treeLevel: 5,
      title: 'survey.mercer-project-manager.q15-question',
      answers: [
        {
          id: '5503f98f-b934-4ae2-8c24-882c70c35f12',
          title: 'general.yes',
          linkedSurveyResultId: '62074a8a-823d-46e1-a828-89c0ba3db86b'
        },
        {
          id: '368bc2ef-1f3d-48a8-94cf-c11f20a48170',
          title: 'general.no',
          linkedSurveyResultId: 'a5224f8f-c716-451d-b90d-718ad33bbc8c'
        }
      ]
    },

    {
      id: '3cdd1eff-2f34-4969-b3bc-835f7cbdac7c',
      treeLevel: 1,
      title: 'survey.mercer-project-manager.q17-question',
      answers: [
        {
          id: 'ee8f5d13-03b4-4a78-ad35-57fbc17ebb51',
          title: 'general.yes',
          linkedSurveyQuestionId: '776d80ef-9f39-49c4-a941-cb5e3cf5cf78'
        },
        {
          id: '127901f1-0716-47cf-b0ba-8b613069a693',
          title: 'general.no',
          linkedSurveyQuestionId: '9aac2c2f-a66d-42e5-9987-39cf44349831'
        }
      ]
    },
    {
      id: '9aac2c2f-a66d-42e5-9987-39cf44349831',
      treeLevel: 2,
      title: 'survey.mercer-project-manager.q18-question',
      answers: [
        {
          id: 'f983900a-87aa-4b31-8033-e5e445482b78',
          title: 'general.yes',
          linkedSurveyQuestionId: 'c48b4f7e-4086-49bd-96a0-20a3f0656231'
        },
        {
          id: 'f453f377-1a1a-4ec2-a04b-5d008d6729c7',
          title: 'general.no',
          linkedSurveyQuestionId: 'c21d4216-3bd1-427c-9c5c-d6448b86822b'
        }
      ]
    },
    {
      id: 'c21d4216-3bd1-427c-9c5c-d6448b86822b',
      treeLevel: 3,
      title: 'survey.mercer-project-manager.q19-question',
      answers: [
        {
          id: '736dc4c0-5cbb-43d4-a34e-1e8f65be1672',
          title: 'general.yes',
          linkedSurveyQuestionId: '5db88381-a91f-4995-9821-c5525078f837'
        },
        {
          id: '9da357dc-70ed-4f54-b603-553988216490',
          title: 'general.no',
          linkedSurveyQuestionId: '86e9078b-036f-4d5d-9133-5997d9aa7e71'
        }
      ]
    },
    {
      id: '86e9078b-036f-4d5d-9133-5997d9aa7e71',
      treeLevel: 4,
      title: 'survey.mercer-project-manager.q20-question',
      answers: [
        {
          id: '0625bb3f-cae0-4333-9bfb-61385229c07b',
          title: 'general.yes',
          linkedSurveyQuestionId: '82ff97a1-2ba4-4836-88d8-4a86b5779498'
        },
        {
          id: '8b4f3e88-4987-407b-a0d0-0b4930328c45',
          title: 'general.no',
          linkedSurveyResultId: '8149133e-7c07-442f-99cb-9aba398a8218'
        }
      ]
    },
    {
      id: '776d80ef-9f39-49c4-a941-cb5e3cf5cf78',
      treeLevel: 2,
      title: 'survey.mercer-project-manager.q21-question',
      answers: [
        {
          id: '49417089-02bc-4302-84c0-e165efac75f4',
          title: 'general.yes',
          linkedSurveyQuestionId: '8416729a-d723-4ece-b4e6-1ef96fa65674'
        },
        {
          id: '6ed39acc-d937-4fa8-b406-c80578ffd72d',
          title: 'general.no',
          linkedSurveyQuestionId: 'ea08eeaf-fc40-409a-a6f7-041041ab94fa'
        }
      ]
    },
    {
      id: 'c48b4f7e-4086-49bd-96a0-20a3f0656231',
      treeLevel: 3,
      title: 'survey.mercer-project-manager.q24-question',
      answers: [
        {
          id: '28270149-e58c-4eec-a5af-1f286a39b7ca',
          title: 'general.yes',
          linkedSurveyQuestionId: '6f99ee96-7739-449b-a916-5c14d9d38b87'
        },
        {
          id: 'd95025de-a10f-4f59-87f6-da65ca6bd684',
          title: 'general.no',
          linkedSurveyQuestionId: '189e906b-4448-4334-a7a9-621118efecb6'
        }
      ]
    },
    {
      id: '5db88381-a91f-4995-9821-c5525078f837',
      treeLevel: 4,
      title: 'survey.mercer-project-manager.q27-question',
      answers: [
        {
          id: 'f4f6e631-2c26-4c43-ae84-42b76f8c5261',
          title: 'general.yes',
          linkedSurveyQuestionId: '75232020-f5c1-4262-9453-0a418f2737f0'
        },
        {
          id: '6c683c40-7804-4987-8356-0296f0c77cd0',
          title: 'general.no',
          linkedSurveyQuestionId: '14cbbce8-0e9a-47a1-b4ec-e385709e8fa6'
        }
      ]
    },
    {
      id: '82ff97a1-2ba4-4836-88d8-4a86b5779498',
      treeLevel: 5,
      title: 'survey.mercer-project-manager.q30-question',
      answers: [
        {
          id: 'a13d71f6-910e-4755-8d1c-b588b677ac8c',
          title: 'general.yes',
          linkedSurveyQuestionId: '5f05b1d1-6246-4b0f-98d0-b97fa736ff3b'
        },
        {
          id: 'e252fb88-1a98-4be2-8c8f-b0223c27a57b',
          title: 'general.no',
          linkedSurveyQuestionId: '8314225e-ec67-4ab9-9a49-eab1078bab21'
        }
      ]
    },

    {
      id: '8416729a-d723-4ece-b4e6-1ef96fa65674',
      treeLevel: 3,
      title: 'survey.mercer-project-manager.q22-question',
      answers: [
        {
          id: 'b6adf1d7-c535-4962-a5da-2bee1c342b46',
          title: 'general.yes',
          linkedSurveyResultId: '39fc925a-9655-4405-9b9f-4cf489131116'
        },
        {
          id: '1be90c8c-cc72-47e1-b756-e25fb76bc885',
          title: 'general.no',
          linkedSurveyResultId: 'b6773ca6-6e10-4662-8a28-fe5528b8bc08'
        }
      ]
    },
    {
      id: 'ea08eeaf-fc40-409a-a6f7-041041ab94fa',
      treeLevel: 3,
      title: 'survey.mercer-project-manager.q23-question',
      answers: [
        {
          id: '7292a976-f9b4-4367-9944-2e56f2abd4b2',
          title: 'general.yes',
          linkedSurveyResultId: 'b4479bf7-c1f5-441f-98ad-ef37ef3b1beb'
        },
        {
          id: '26a8b34a-9b98-45e4-a087-a73ab138a8d5',
          title: 'general.no',
          linkedSurveyResultId: '9368ce67-99c4-4ad6-a0eb-59513cd3042f'
        }
      ]
    },
    {
      id: '6f99ee96-7739-449b-a916-5c14d9d38b87',
      treeLevel: 4,
      title: 'survey.mercer-project-manager.q25-question',
      answers: [
        {
          id: '370f1660-7011-42d5-9377-75080a8fd67b',
          title: 'general.yes',
          linkedSurveyResultId: 'd34291e9-7099-4c19-8e91-660832d0f990'
        },
        {
          id: '933afdf6-7fb1-47e5-a7a4-0e695210cae4',
          title: 'general.no',
          linkedSurveyResultId: 'd1723770-e0fd-4841-9f0c-cc9bbda8363d'
        }
      ]
    },
    {
      id: '189e906b-4448-4334-a7a9-621118efecb6',
      treeLevel: 4,
      title: 'survey.mercer-project-manager.q26-question',
      answers: [
        {
          id: '5490bc4c-ec16-4512-9a8c-88fc3127f992',
          title: 'general.yes',
          linkedSurveyResultId: '8253a41f-f7c8-4b8f-9268-a35969c9d3f3'
        },
        {
          id: '570cf517-9896-4081-90d2-cf222cfd9688',
          title: 'general.no',
          linkedSurveyResultId: 'ccfd1d43-0de3-49ca-b416-bb844585200d'
        }
      ]
    },
    {
      id: '75232020-f5c1-4262-9453-0a418f2737f0',
      treeLevel: 5,
      title: 'survey.mercer-project-manager.q28-question',
      answers: [
        {
          id: 'e3d1228b-f5e7-4bd9-9b52-8316e515cdc3',
          title: 'general.yes',
          linkedSurveyResultId: '5d8c1bec-f0a5-4602-9f4b-65fd45c8a034'
        },
        {
          id: '5afff03d-e04f-403f-b89e-7218872b2fc6',
          title: 'general.no',
          linkedSurveyResultId: 'd813cbcd-faab-4203-8217-d860989a3e8f'
        }
      ]
    },
    {
      id: '14cbbce8-0e9a-47a1-b4ec-e385709e8fa6',
      treeLevel: 5,
      title: 'survey.mercer-project-manager.q29-question',
      answers: [
        {
          id: '143a7915-d223-4c87-b48e-d1738a3dc947',
          title: 'general.yes',
          linkedSurveyResultId: '9ad6de6d-d69d-466b-b014-a9a8fee22db8'
        },
        {
          id: '36f26a49-0841-448e-857e-638c763ecf71',
          title: 'general.no',
          linkedSurveyResultId: '4c7193aa-2f54-49a8-9029-9301c9cf67df'
        }
      ]
    },
    {
      id: '5f05b1d1-6246-4b0f-98d0-b97fa736ff3b',
      treeLevel: 6,
      title: 'survey.mercer-project-manager.q31-question',
      answers: [
        {
          id: '8abc1360-9c39-4234-ad59-67c3520b8f6f',
          title: 'general.yes',
          linkedSurveyResultId: '926eaabd-9848-4432-8908-fcdee1c60cad'
        },
        {
          id: 'd62be243-be95-4587-a0df-308a946b005c',
          title: 'general.no',
          linkedSurveyResultId: '5bb8796b-83fe-4e4c-a53f-124389d2f6cf'
        }
      ]
    },
    {
      id: '8314225e-ec67-4ab9-9a49-eab1078bab21',
      treeLevel: 6,
      title: 'survey.mercer-project-manager.q32-question',
      answers: [
        {
          id: '15ceb09f-bcb3-4765-b108-908af623d5aa',
          title: 'general.yes',
          linkedSurveyResultId: '6434b747-5713-4e1d-a6ad-307140e78138'
        },
        {
          id: '230bd3ff-bc9d-40ea-9bb3-3a14a1e344ef',
          title: 'general.no',
          linkedSurveyResultId: '54df0350-3cc2-447a-b5de-f71552ca690b'
        }
      ]
    }
  ],
  results: [
    {
      id: '669c2880-66be-473a-a2bf-d3db999dc174',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M6',
      positionClass: 62,
      jobCode: 'PPM.01.002.M60'
    },
    {
      id: 'b0511ed0-241f-435d-977c-147da3fbd88c',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4',
      positionClass: 59,
      jobCode: 'PPM.01.002.M40'
    },
    {
      id: '1dfe08d4-abbc-419e-ad24-aecbe92ceeaf',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M6',
      positionClass: 61,
      jobCode: 'PPM.01.002.M60'
    },
    {
      id: 'eb7d4e92-a61c-4dca-aa77-d1b123e0236c',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4',
      positionClass: 58,
      jobCode: 'PPM.01.002.M40'
    },
    {
      id: 'a97ba484-b880-408d-82ad-2a1c46667554',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4',
      positionClass: 58,
      jobCode: 'PPM.01.002.M40'
    },
    {
      id: '99ac1b82-43d7-44e1-8dd7-b831ee3f6f28',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M2',
      positionClass: 56,
      jobCode: 'PPM.01.002.M20'
    },
    {
      id: 'd8cc6063-c1b8-41dc-a944-3f31e177743c',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4',
      positionClass: 57,
      jobCode: 'PPM.01.002.M40'
    },
    {
      id: 'd8aa96c8-41a1-4334-bc96-f76b08ad9370',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M2',
      positionClass: 55,
      jobCode: 'PPM.01.002.M20'
    },
    {
      id: '7111628f-773f-420a-8f87-22f8fbf604bc',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P4',
      positionClass: 56,
      jobCode: 'PPM.01.002.P40'
    },
    {
      id: 'a8999851-8244-47bd-a917-f47e738db294',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3',
      positionClass: 54,
      jobCode: 'PPM.01.002.P30'
    },
    {
      id: '62074a8a-823d-46e1-a828-89c0ba3db86b',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P4',
      positionClass: 55,
      jobCode: 'PPM.01.002.P40'
    },
    {
      id: 'a5224f8f-c716-451d-b90d-718ad33bbc8c',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3',
      positionClass: 53,
      jobCode: 'PPM.01.002.P30'
    },
    {
      id: '17120a3d-964c-4efd-80af-b8a3a4f5fe39',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3',
      positionClass: 53,
      jobCode: 'PPM.01.002.P30'
    },
    {
      id: 'ddfaabe2-4fb3-4466-97c1-78bcc7c4140e',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3',
      positionClass: 51,
      jobCode: 'PPM.01.002.P30'
    },
    {
      id: '39fc925a-9655-4405-9b9f-4cf489131116',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M6',
      positionClass: 59,
      jobCode: 'PPM.01.002.M60'
    },
    {
      id: 'b6773ca6-6e10-4662-8a28-fe5528b8bc08',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4',
      positionClass: 57,
      jobCode: 'PPM.01.002.M40'
    },
    {
      id: 'b4479bf7-c1f5-441f-98ad-ef37ef3b1beb',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M6',
      positionClass: 58,
      jobCode: 'PPM.01.002.M60'
    },
    {
      id: '9368ce67-99c4-4ad6-a0eb-59513cd3042f',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4',
      positionClass: 56,
      jobCode: 'PPM.01.002.M40'
    },
    {
      id: 'd34291e9-7099-4c19-8e91-660832d0f990',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4',
      positionClass: 56,
      jobCode: 'PPM.01.002.M40'
    },
    {
      id: 'd1723770-e0fd-4841-9f0c-cc9bbda8363d',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M2',
      positionClass: 55,
      jobCode: 'PPM.01.002.M20'
    },
    {
      id: '8253a41f-f7c8-4b8f-9268-a35969c9d3f3',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4',
      positionClass: 55,
      jobCode: 'PPM.01.002.M40'
    },
    {
      id: 'ccfd1d43-0de3-49ca-b416-bb844585200d',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M2',
      positionClass: 54,
      jobCode: 'PPM.01.002.M20'
    },
    {
      id: '5d8c1bec-f0a5-4602-9f4b-65fd45c8a034',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P4',
      positionClass: 54,
      jobCode: 'PPM.01.002.P40'
    },
    {
      id: 'd813cbcd-faab-4203-8217-d860989a3e8f',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3',
      positionClass: 53,
      jobCode: 'PPM.01.002.P30'
    },
    {
      id: '9ad6de6d-d69d-466b-b014-a9a8fee22db8',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P4',
      positionClass: 53,
      jobCode: 'PPM.01.002.P40'
    },
    {
      id: '4c7193aa-2f54-49a8-9029-9301c9cf67df',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3',
      positionClass: 52,
      jobCode: 'PPM.01.002.P30'
    },
    {
      id: '926eaabd-9848-4432-8908-fcdee1c60cad',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3',
      positionClass: 51,
      jobCode: 'PPM.01.002.P30'
    },
    {
      id: '5bb8796b-83fe-4e4c-a53f-124389d2f6cf',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P2',
      positionClass: 50,
      jobCode: 'PPM.01.002.P20'
    },
    {
      id: '6434b747-5713-4e1d-a6ad-307140e78138',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3',
      positionClass: 51,
      jobCode: 'PPM.01.002.P30'
    },
    {
      id: '54df0350-3cc2-447a-b5de-f71552ca690b',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P2',
      positionClass: 50,
      jobCode: 'PPM.01.002.P20'
    },
    {
      id: '8149133e-7c07-442f-99cb-9aba398a8218',
      differentSurveyType: MercerSurveyType.Default
    }
  ]
};
